import React, { useEffect, useState } from "react";
import { api } from "../../../api";
import { useDispatch } from "react-redux";
import { setSelectedRecommendedAction } from "../../../store/projects/actions";
import { calculateReforestation } from "../utils/calculateReforestation";

export const useRecommendationData = (id: string, projectData: any) => {
  const dispatch = useDispatch();
  const [geoJsonObjects, setGeoJsonObjects] = useState<Array<GeoJSON.FeatureCollection<any>>>();
  const [recommendationProjectData, setRecommendationProjectData] = useState({
    sumOfConservation: 0,
    sumOfReforestationHigh: 0,
    sumOfReforestationLow: 0,
    sumOfReforestationMedium: 0,
    sumOfAboveGroundBiomassTonnes: 0,
    sumOfSoilOrganicCarbonTonnes: 0,
  });

  useEffect(() => {
    const fetchAllData = async () => {
      let projectResponseData = projectData;
      // console.log("projectResponseData =>", projectResponseData);
      if (projectData?.id !== id) {
        dispatch(setSelectedRecommendedAction(undefined));
        const projectResponse = await api.get(`/v2/mangrove-recommendation/${id}`);
        projectResponseData = projectResponse.data;
        dispatch(setSelectedRecommendedAction(projectResponseData));
      }

      if (Object.hasOwn(projectResponseData, "isAggregated")) {
        const responseAggregated = await api.get(
          `/v2/aggregate-recommendation-features/mangrove/?country_code=${projectResponseData?.country_code}&adm_name=${projectResponseData?.adm_name}`,
        );
        setGeoJsonObjects(responseAggregated?.data);
      } else {
        const polygonResponse = await api.get(
          `/v2/recommendation-polygon-features/?adm2=${projectResponseData?.adm2}&type=${projectResponseData?.type}`,
        );
        setGeoJsonObjects(polygonResponse?.data?.features);

        const reforestationResponse = await calculateReforestation(
          polygonResponse?.data,
          projectResponseData,
        );
        setRecommendationProjectData({
          sumOfConservation: reforestationResponse?.sumOfConservation ?? 0,
          sumOfReforestationHigh: reforestationResponse?.sumOfReforestationHigh ?? 0,
          sumOfReforestationLow: reforestationResponse?.sumOfReforestationLow ?? 0,
          sumOfReforestationMedium: reforestationResponse?.sumOfReforestationMedium ?? 0,
          sumOfAboveGroundBiomassTonnes: reforestationResponse?.sumOfAboveGroundBiomassTonnes ?? 0,
          sumOfSoilOrganicCarbonTonnes: reforestationResponse?.sumOfSoilOrganicCarbonTonnes ?? 0,
        });
      }
    };

    if (id) {
      fetchAllData().catch(console.error);
    }
  }, [id]);

  return {
    geoJsonObjects,
    recommendationProjectData,
  };
};
